// ** Redux Imports
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'

// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'

const config = useJwt.jwtConfig

const initialUser = () => {
  const item = window.localStorage.getItem('userData')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {}
}

export const postLogin = createAsyncThunk('login/getToken', async (params) => {
  const response = await useJwt.login(params)
  return {login_data: response.data}
})

export const isRequiredChangePassword = createAsyncThunk('login/isRequiredChangePassword', async (params) => {
  const response = await useJwt.isRequiredChangePassword(params)
  return {isRequiredChangePassword: response.data}
})

export const getPasswordStatus = createAsyncThunk('login/getPasswordStatus', async (username) => {
  const response = await useJwt.getPasswordStatus(username)
  return {changePassword: response.data.changePassword}
})

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    userData: initialUser(),
    isChangePassword: false
  },
  reducers: {
    handleLogin: (state, action) => {
      // console.log(state, action)
      state.userData = action.payload
      state[config.storageTokenKeyName] =
        action.payload[config.storageTokenKeyName]
      // state[config.storageRefreshTokenKeyName] = action.payload[config.storageRefreshTokenKeyName]
      localStorage.setItem('userData', JSON.stringify(action.payload))
      localStorage.setItem(
        config.storageTokenKeyName,
        action.payload.accessToken
      )
      // localStorage.setItem(config.storageRefreshTokenKeyName, JSON.stringify(action.payload.refreshToken))
    },
    handleLogout: (state) => {
      state.userData = {}
      state[config.storageTokenKeyName] = null
      state[config.storageRefreshTokenKeyName] = null
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem(config.storageTokenKeyName)
      localStorage.removeItem(config.storageRefreshTokenKeyName)
    },
    handeChangeUserData: (state, action) => {
      state.userData = {...state.userData, ...action.payload}
      const newUserData = {...state.userData, ...action.payload}
      localStorage.setItem('userData', JSON.stringify(newUserData))
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postLogin.fulfilled, (state, action) => {
      state.userData = action.payload.login_data
      if (state.userData) {
      }
    })
  },
})

export const {handleLogin, handleLogout, handeChangeUserData} = authSlice.actions

export default authSlice.reducer
